import { useCallback, useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';

import * as Meta from '@Queries/Meta';
import { useRequest } from '@Contexts/Request';
import { useDeps } from '@Contexts/DI';
import saveSurvey from '@Api/Site/saveSurvey';

import type { BaseSavedSurvey, FullSavedSurvey, SavedSurvey } from '@Types/Survey';

const useSubmitSurvey = () => {
  const { device, country } = useRequest();
  const { logger } = useDeps();
  const meta = Meta.useMeta();

  const key = ['save-survey'];

  const baseSurvey: BaseSavedSurvey = useMemo(() => {
    return {
      url: location.href,
      country: country,
      region: meta.data?.region.name,
      browser: device.client.name,
      device: device.device.type,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    };
  }, [country, device, meta]);

  const submit = useCallback(
    async (survey: SavedSurvey) => {
      try {
        const fullSurvey: FullSavedSurvey = { ...baseSurvey, ...survey };

        await saveSurvey(fullSurvey);
      } catch (error) {
        logger.error(error);
        throw error;
      }
    },
    [baseSurvey, logger],
  );

  return useMutation({
    mutationKey: key,
    mutationFn: submit,
  });
};

export default useSubmitSurvey;
